<template>
  <div class="loader-container">
    <div class="loader-container__animation-wrapper">
      <lottie-animation
        :animation-data="ReallyLoaderJson"
        auto-play
        loop
        :speed="1"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { LottieAnimation } from "lottie-web-vue";
import ReallyLoaderJson from "../../../public/animations/really-loader.json";
</script>

<style lang="scss" scoped>
.loader-container {
  background-color: $color-primary-pink;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;

  &__animation-wrapper {
    max-width: 10rem;
  }

  &__loader-text {
    font-size: $font-size-base;
    font-weight: $font-weight-regular;
    color: $color-black;
    margin-top: 1.6rem;
    text-align: center;
  }
}
</style>
